import * as React from 'react';

const MicrosoftIconSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#f25022" d="M0 0h8.5v8.5H0z" />
      <path fill="#00a4ef" d="M9.5 0H18v8.5H9.5z" />
      <path fill="#7fba00" d="M0 9.5h8.5V18H0z" />
      <path fill="#ffb900" d="M9.5 9.5H18V18H9.5z" />
    </svg>
  );
};

export default MicrosoftIconSVG;
